class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.logo = this.header.querySelector('[data-header-logo]');
        this.headerBounds = {};

        this.setHeaderHeight();

        window.addEventListener('resize', this.setHeaderHeight.bind(this));
        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Smooth logo resize logic
        const maxScroll = 75;
        const minLogoWidth = 170;
        const maxLogoWidth = 275;

        // Calculate new width based on scroll
        let newLogoWidth;
        if (scrollTop >= maxScroll) {
            newLogoWidth = minLogoWidth;
        } else if (scrollTop <= 0) {
            newLogoWidth = maxLogoWidth;
        } else {
            const scrollFraction = scrollTop / maxScroll;
            newLogoWidth = maxLogoWidth - ((maxLogoWidth - minLogoWidth) * scrollFraction);
        }

        // Apply the new width smoothly
        this.logo.style.width = `${newLogoWidth}px`;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.classList.remove('header--hidden');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
            this.classList.add('header--hidden');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    reveal() {
        // console.log('');
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        // console.log('');
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    hide() {
        // console.log('');
    }
}

customElements.define('sticky-header', StickyHeader);